<ion-grid [ngClass]="{card: true, highlighted: cardData.highlighted}" (click)="onCardClick()">
  <ion-row>
    <ion-col size="6">
      <ion-row>
        <ion-col>
          <ion-text class="project-name">{{cardData.project.Name}}</ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-text>({{cardData.project.Number}})</ion-text>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="5">
      <ion-row>
        <ion-col>
          <ion-text class="total-mileage">Total Mileage: {{cardData.odometerReading.IsClosed ? (cardData.odometerReading.Mileage | number) + " miles" : "-"}}</ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-text>Odometer Start: {{cardData.odometerReading.OdometerStart | number}}</ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-text>Odometer End: {{(cardData.odometerReading.OdometerEnd | number) ?? "-"}}</ion-text>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="1" class="icon">
      <ion-icon name="chevron-forward"></ion-icon>
    </ion-col>
  </ion-row>
</ion-grid>
